const state = {
  languageOPT_: ["English","中文","Indonesia","Tiếng Việt","Thai ไทย","ភាសាខ្មែរ"],
  language_: [],
  langTreeSelect: [
    {id: 'en', label: 'EN (English)'},
    {id: 'cn',label: 'CN (Chinese)'},
    {id: 'th',label: 'TH (Thai)'},
    {id: 'vn',label: 'VN (Vietnamese)'},
    {id: 'kh',label: 'KH (Khmer)'},
    {id: 'id',label: 'ID (Indonesian)'},
    {id: 'kr',label: 'KR (Korean)'},
    {id: 'jp',label: 'JP (Japanese)'},
    {id: 'ma',label: 'MA (Malaysian)'},
    {id: 'ger',label: 'GER (German)'},
    { id: 'my', label: 'MM (Myanmar)' },
    { id: 'bn', label: 'BD (Bangladesh)' }],
  langIndex: 0,
  langCode: 'en'
}
const getters = {
  getLanguage: state => {
    return state.language_
  },
  getLanguageOPT: state => {
    return state.languageOPT_
  },
  getLanguageIndex: state => {
    return state.langIndex
  },
  getLangTreeSelect: state => {
    return state.langTreeSelect
  },
  getLangCode: state => {
    return state.langTreeSelect[state.langIndex].id
  }
}
const mutations = {
  setLanguage(state, value) {
    state.language_ = value
  },
  setLanguageIndex(state, value) {
    state.langIndex = value
  },
  setLangTreeSelect(state, value) {
    state.langTreeSelect = value
  }
}
const actions = {
  setLanguage({commit}, value) {
    commit('setLanguage', value)
  },
  setLanguageIndex({commit}, value) {
    commit('setLanguageIndex', value)
  },
  setLangTreeSelect({commit}, value) {
    commit('setLangTreeSelect', value)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/Language.js